var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBlackStepBgSm(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 282,
    height: 37,
    viewBox: "0 0 282 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 281,
    height: 18,
    transform: "matrix(1 0 0 -1 0.630859 18.7644)",
    fill: "#292B33"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 147,
    height: 17,
    transform: "matrix(1 0 0 -1 0.630859 36.7644)",
    fill: "#292B33"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 161.662,
    y: 36.9465,
    width: 17.1822,
    height: 0.687298,
    transform: "rotate(-90 161.662 36.9465)",
    fill: "#292B33"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 148.605,
    y: 36.9465,
    width: 17.1822,
    height: 0.687298,
    transform: "rotate(-90 148.605 36.9465)",
    fill: "#292B33"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 158.916,
    y: 36.9465,
    width: 17.1822,
    height: 0.687298,
    transform: "rotate(-90 158.916 36.9465)",
    fill: "#292B33"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 149.979,
    y: 36.9465,
    width: 17.1822,
    height: 1.37459,
    transform: "rotate(-90 149.979 36.9465)",
    fill: "#292B33"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 153.416,
    y: 36.9465,
    width: 17.1822,
    height: 2.06187,
    transform: "rotate(-90 153.416 36.9465)",
    fill: "#292B33"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 156.166,
    y: 36.9465,
    width: 17.1822,
    height: 0.687298,
    transform: "rotate(-90 156.166 36.9465)",
    fill: "#292B33"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackStepBgSm);
export default __webpack_public_path__ + "static/media/black-step-bg-sm.479a3846c8a5c687472a38f48b385d81.svg";
export { ForwardRef as ReactComponent };